export { ViewBoards as default } from './ViewBoards';
